export function getQueryParams(param: string): string | null {
	return new URL(window.location.href).searchParams.get(param);
}

export function setQueryParams(param: string, value: string, replace = false): void {
	const url = new URL(window.location.href);

	url.searchParams.set(param, value);
	console.log(param);

	if (!replace) {
		window.history.pushState({}, '', url);
	} else {
		window.history.replaceState({}, '', url);
	}
}
